'use client';

import { c as _c } from "react/compiler-runtime";
import { BsGeoAltFill } from 'react-icons/bs';
import { type OptionProps } from 'react-select';
import { components } from 'react-select';
import { type Place } from '@/features/place/types/place-types';
import styles from './search-place-option-new.module.scss';
export default function SearchPlaceOptionNew(props) {
  const $ = _c(6);
  const {
    children
  } = props;
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className={styles.option_icon}><BsGeoAltFill /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== children) {
    t1 = <div className={styles.option_link}>{t0}<span>{children}</span></div>;
    $[1] = children;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== props || $[4] !== t1) {
    t2 = <components.Option {...props}>{t1}</components.Option>;
    $[3] = props;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
}